import { makeStyles } from '@material-ui/core/styles';
import { chartTooltipStyles } from '../chartTooltip/styles';

const useStyles = makeStyles(() => ({
  chartWrapper: { ...chartTooltipStyles },
  paperOverflow: { overflow: 'visible' },
}));

export default useStyles;
